export default {
    navigationBarTitleText: '进度验收'
  };
  